/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SharedserviceMelcoModelsDesign,
    SharedserviceMelcoModelsDesignFromJSON,
    SharedserviceMelcoModelsDesignToJSON,
    SharedserviceMelcoModelsDesignReferences,
    SharedserviceMelcoModelsDesignReferencesFromJSON,
    SharedserviceMelcoModelsDesignReferencesToJSON,
    SharedserviceMelcoModelsError,
    SharedserviceMelcoModelsErrorFromJSON,
    SharedserviceMelcoModelsErrorToJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItem,
    SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItemFromJSON,
    SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItemToJSON,
    SharedserviceMelcoModelsNotification,
    SharedserviceMelcoModelsNotificationFromJSON,
    SharedserviceMelcoModelsNotificationToJSON,
    SharedserviceMelcoModelsUpdateDesign,
    SharedserviceMelcoModelsUpdateDesignFromJSON,
    SharedserviceMelcoModelsUpdateDesignToJSON,
} from '../models';

export interface DesignsDraftApiUserDesignsDeleteRequest {
    id: string;
    force?: boolean;
}

export interface DesignsDraftApiUserDesignsDownloadRequest {
    id: string;
    publishState?: string;
}

export interface DesignsDraftApiUserDesignsDuplicateDraftRequest {
    id: string;
}

export interface DesignsDraftApiUserDesignsGetDefRequest {
    id: string;
    publishState?: string;
}

export interface DesignsDraftApiUserDesignsPreviewRequest {
    id: string;
    width?: number;
    publishState?: string;
}

export interface DesignsDraftApiUserDesignsPrintQueueUpdateFileDraftRequest {
    id: string;
    file?: Blob;
}

export interface DesignsDraftApiUserDesignsPrintQueueUploadDraftRequest {
    file?: Blob;
}

export interface DesignsDraftApiUserDesignsPublishRequest {
    id: string;
}

export interface DesignsDraftApiUserDesignsReferencesRequest {
    id: string;
}

export interface DesignsDraftApiUserDesignsRevertRequest {
    id: string;
}

export interface DesignsDraftApiUserDesignsSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    publishState?: string;
    service?: string;
}

export interface DesignsDraftApiUserDesignsUpdateDraftRequest {
    id: string;
    sharedserviceMelcoModelsUpdateDesign?: SharedserviceMelcoModelsUpdateDesign;
}

export interface DesignsDraftApiUserDesignsUpdateDraftFileRequest {
    id: string;
    file?: Blob;
}

export interface DesignsDraftApiUserDesignsUploadDraftRequest {
    file?: Blob;
}

/**
 * 
 */
export class DesignsDraftApi extends runtime.BaseAPI {

    /**
     */
    async userDesignsDeleteRaw(requestParameters: DesignsDraftApiUserDesignsDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['Force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userDesignsDelete(requestParameters: DesignsDraftApiUserDesignsDeleteRequest): Promise<void> {
        await this.userDesignsDeleteRaw(requestParameters);
    }

    /**
     */
    async userDesignsDownloadRaw(requestParameters: DesignsDraftApiUserDesignsDownloadRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsDownload.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/{Id}/download`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async userDesignsDownload(requestParameters: DesignsDraftApiUserDesignsDownloadRequest): Promise<Blob> {
        const response = await this.userDesignsDownloadRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsDuplicateDraftRaw(requestParameters: DesignsDraftApiUserDesignsDuplicateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesign>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsDuplicateDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/{Id}/duplicate/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsDuplicateDraft(requestParameters: DesignsDraftApiUserDesignsDuplicateDraftRequest): Promise<SharedserviceMelcoModelsDesign> {
        const response = await this.userDesignsDuplicateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsGetDefRaw(requestParameters: DesignsDraftApiUserDesignsGetDefRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesign>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsGetDef.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsGetDef(requestParameters: DesignsDraftApiUserDesignsGetDefRequest): Promise<SharedserviceMelcoModelsDesign> {
        const response = await this.userDesignsGetDefRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsPreviewRaw(requestParameters: DesignsDraftApiUserDesignsPreviewRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsPreview.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.width !== undefined) {
            queryParameters['width'] = requestParameters.width;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/{Id}/preview`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userDesignsPreview(requestParameters: DesignsDraftApiUserDesignsPreviewRequest): Promise<void> {
        await this.userDesignsPreviewRaw(requestParameters);
    }

    /**
     */
    async userDesignsPrintQueueUpdateFileDraftRaw(requestParameters: DesignsDraftApiUserDesignsPrintQueueUpdateFileDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsNotification>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsPrintQueueUpdateFileDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/designs/printqueue/{Id}/update/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsNotificationFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsPrintQueueUpdateFileDraft(requestParameters: DesignsDraftApiUserDesignsPrintQueueUpdateFileDraftRequest): Promise<SharedserviceMelcoModelsNotification> {
        const response = await this.userDesignsPrintQueueUpdateFileDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsPrintQueueUploadDraftRaw(requestParameters: DesignsDraftApiUserDesignsPrintQueueUploadDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsNotification>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/designs/printqueue/upload/draft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsNotificationFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsPrintQueueUploadDraft(requestParameters: DesignsDraftApiUserDesignsPrintQueueUploadDraftRequest): Promise<SharedserviceMelcoModelsNotification> {
        const response = await this.userDesignsPrintQueueUploadDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsPublishRaw(requestParameters: DesignsDraftApiUserDesignsPublishRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesign>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsPublish.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/{Id}/publish`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsPublish(requestParameters: DesignsDraftApiUserDesignsPublishRequest): Promise<SharedserviceMelcoModelsDesign> {
        const response = await this.userDesignsPublishRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsReferencesRaw(requestParameters: DesignsDraftApiUserDesignsReferencesRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesignReferences>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsReferences.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/{Id}/references`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignReferencesFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsReferences(requestParameters: DesignsDraftApiUserDesignsReferencesRequest): Promise<SharedserviceMelcoModelsDesignReferences> {
        const response = await this.userDesignsReferencesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsRevertRaw(requestParameters: DesignsDraftApiUserDesignsRevertRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsRevert.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs/{Id}/revert`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userDesignsRevert(requestParameters: DesignsDraftApiUserDesignsRevertRequest): Promise<void> {
        await this.userDesignsRevertRaw(requestParameters);
    }

    /**
     */
    async userDesignsSearchRaw(requestParameters: DesignsDraftApiUserDesignsSearchRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        if (requestParameters.service !== undefined) {
            queryParameters['service'] = requestParameters.service;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/designs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItemFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsSearch(requestParameters: DesignsDraftApiUserDesignsSearchRequest): Promise<SharedserviceMelcoModelsGenericList1MelcoModelsDesignListItem> {
        const response = await this.userDesignsSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsUpdateDraftRaw(requestParameters: DesignsDraftApiUserDesignsUpdateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesign>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsUpdateDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/designs/{Id}/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoModelsUpdateDesignToJSON(requestParameters.sharedserviceMelcoModelsUpdateDesign),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsUpdateDraft(requestParameters: DesignsDraftApiUserDesignsUpdateDraftRequest): Promise<SharedserviceMelcoModelsDesign> {
        const response = await this.userDesignsUpdateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsUpdateDraftFileRaw(requestParameters: DesignsDraftApiUserDesignsUpdateDraftFileRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesign>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsUpdateDraftFile.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/designs/{Id}/update/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsUpdateDraftFile(requestParameters: DesignsDraftApiUserDesignsUpdateDraftFileRequest): Promise<SharedserviceMelcoModelsDesign> {
        const response = await this.userDesignsUpdateDraftFileRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsUploadDraftRaw(requestParameters: DesignsDraftApiUserDesignsUploadDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsDesign>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/designs/upload/draft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsUploadDraft(requestParameters: DesignsDraftApiUserDesignsUploadDraftRequest): Promise<SharedserviceMelcoModelsDesign> {
        const response = await this.userDesignsUploadDraftRaw(requestParameters);
        return await response.value();
    }

}
